import { useMutation } from '@tanstack/react-query';
import { couponService } from '@/services/coupon.service';
import { toast } from 'sonner';

interface ValidateCouponParams {
  code: string;
  orderAmount: number;
  userId: string;
}

export const useValidateCoupon = () => {
  return useMutation({
    mutationFn: ({ code, orderAmount, userId }: ValidateCouponParams) =>
      couponService.validateCoupon(code, orderAmount, userId),
    onError: (error: any) => {
      toast.error(error?.message || 'Failed to validate coupon');
    },
  });
};